exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-field-badges[data-v-1cb29a19] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 0.5rem;\n}\n.custom-field-badge[data-v-1cb29a19] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 0.2rem 0.6rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  line-height: 1.2;\n  background: #eceff1;\n  color: #455a64;\n  white-space: nowrap;\n}\n", ""]);

// exports
